// Route prefix -> issue-tracker module key, shared by the report panel (auto-detect) and the
// Issues page (module filter and labels). Matched longest-prefix first, so "/admin/leave"
// wins over "/admin" and "/reports/leave" over "/reports".

export const MODULE_LABELS: Record<string, string> = {
  dashboard: "Dashboard",
  employees: "Employees",
  attendance: "Attendance",
  leave: "Leave",
  timesheet: "Timesheets",
  payroll: "Payroll",
  expenses: "Expenses",
  assets: "Assets",
  contractors: "Contractors",
  performance: "Performance",
  learning: "Learning",
  succession: "Succession",
  "org-chart": "Org Hierarchy",
  grievance: "Grievance",
  offboarding: "Offboarding",
  onboarding: "Onboarding",
  reports: "Reports",
  issues: "Issue Tracker",
  "admin-leave": "Leave Admin",
  "admin-email-templates": "Email Templates",
  "admin-issue-tracker": "Issue Tracker Settings",
  admin: "Admin",
  login: "Login",
  other: "Other",
};

const MODULE_ROUTES: [prefix: string, key: string][] = [
  ["/dashboard", "dashboard"],
  ["/employees", "employees"],
  ["/attendance", "attendance"],
  ["/leave", "leave"],
  ["/timesheet", "timesheet"],
  ["/payroll", "payroll"],
  ["/expenses", "expenses"],
  ["/assets", "assets"],
  ["/contractors", "contractors"],
  ["/performance", "performance"],
  ["/learning", "learning"],
  ["/succession", "succession"],
  ["/org-chart", "org-chart"],
  ["/grievance", "grievance"],
  ["/offboarding", "offboarding"],
  ["/onboarding", "onboarding"],
  ["/handbook", "onboarding"],
  ["/reports", "reports"],
  ["/issues", "issues"],
  ["/admin/leave", "admin-leave"],
  ["/admin/email-templates", "admin-email-templates"],
  ["/admin/issue-tracker", "admin-issue-tracker"],
  ["/admin", "admin"],
  ["/login", "login"],
  ["/setup-mfa", "login"],
];

const BY_LENGTH = [...MODULE_ROUTES].sort((a, b) => b[0].length - a[0].length);

/** Module key for a pathname, or undefined when no route prefix matches. */
export function detectModule(pathname: string): string | undefined {
  for (const [prefix, key] of BY_LENGTH) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return key;
  }
  return undefined;
}

/** Display label for a stored module key; older issues stored free text, shown as-is. */
export function moduleLabel(key: string | null | undefined): string {
  if (!key) return "—";
  return MODULE_LABELS[key] ?? MODULE_LABELS[key.toLowerCase()] ?? key;
}
